import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import { McpAuthorize } from './pages/McpAuthorize';
import { OAuthAuthorize } from './pages/OAuthAuthorize';
import { AuthProvider } from './contexts/AuthContext';
import { SoundProvider } from './contexts/SoundContext';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <SoundProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<App />} />
            <Route path="/mcp" element={<McpAuthorize />} />
            <Route path="/oauth/authorize" element={<OAuthAuthorize />} />
          </Routes>
        </BrowserRouter>
      </SoundProvider>
    </AuthProvider>
  </React.StrictMode>
);
